import { ref } from 'vue';

const pageInformation = ref({
  type: '',
});

export default function getPageInformation(options = {}) {
  pageInformation.value = Object.assign(pageInformation.value, options);
  return pageInformation;
}
